import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 8A29D85F-1BAD-4610-AF2F-B4AF0F0D2755
 * name led-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/led-off.svg
 * tags
 * - Home Automation 
 */
export const LedOffIcon = createSvgIcon(<><path d="M12,6A4,4 0 0,0 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10A4,4 0 0,0 12,6Z" /></>, 'LedOffIcon');
export default LedOffIcon